import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { JSX } from "react";
import { handleLogout } from "./API/ApiEnpoints";
import "../styles/Sidebar.css";
import { MdHomeFilled } from "react-icons/md";
import { RiBarChartFill } from "react-icons/ri";
import { GiTeamDowngrade } from "react-icons/gi";
import { GoPeople } from "react-icons/go";
import { RiTrophyLine, RiOrganizationChart } from "react-icons/ri";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { GoGoal } from "react-icons/go";
import { FaHandHoldingHeart, FaPersonRunning } from "react-icons/fa6";
import { IoMdSettings } from "react-icons/io";
import sidebarlogo from "./assets/sidebarlogo.png";
import { CgLogOut } from "react-icons/cg";
import ConfirmationDialog from "./utils/ConfirmationDialog";
import { RiUserSettingsLine } from "react-icons/ri";
import { MdDashboard } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import { FiActivity } from "react-icons/fi";
import { ImProfile } from "react-icons/im";
import { BiNews, BiCog } from "react-icons/bi";
import { FaLightbulb } from "react-icons/fa";

interface MenuItem {
  text: string;
  icon: JSX.Element;
  link?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  subMenu?: MenuItem[]; // Optional submenus
}

interface SideBarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const SideBar: React.FC<SideBarProps> = ({ isOpen, toggleSidebar }) => {
  const [Logo, setLogo] = useState<string>(sidebarlogo);
  const [isNavOpen, setIsNavOpen] = useState<boolean>(true);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [activeTab, setActiveTab] = useState<string>("Home");
  const [activeSubMenu, setActiveSubMenu] = useState<string | null>(null);
  const [showLogoutDialog, setShowLogoutDialog] = useState<boolean>(false);

  const privilege = localStorage.getItem("privilege");
  const user_role = localStorage.getItem("user_role");
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSubMenuItem, setActiveSubMenuItem] = useState<string | null>(
    location.pathname
  );

  const toggleNav = () => setIsNavOpen(!isNavOpen);

  const menuItems: MenuItem[] = [
    { text: "Home", icon: <MdHomeFilled />, link: "/home" },
    {
      text: "Me",
      icon: <RiBarChartFill />,
      subMenu: [
        { text: "Dashboard", icon: <MdDashboard />, link: "/me-dashboard" },
        {
          text: "Achievements",
          icon: <RiTrophyLine />,
          link: "/achievements",
        },
        { text: "Activity", icon: <FiActivity />, link: "/activity" },
        {
          text: "Health Form",
          icon: <FaHandHoldingHeart />,
          link: "/health-form",
        },
        {
          text: "Insights",
          icon: <FaLightbulb />,
          link: "/insights",
        },
      ],
    },
    { text: "My Org", icon: <RiOrganizationChart />, link: "/my-org" },
    {
      text: "Teams",
      icon: <GoPeople />,
      subMenu: [
        // { text: "Dashboard", icon: <MdDashboard />, link: "/teams-dashboard" },
        { text: "Team Dashboard", icon: <MdDashboard />, link: "/team-stats" },

        {
          text: "View Teams",
          icon: <GiTeamDowngrade />,
          link: "/view-teams",
        },

        { text: "Leaderboard", icon: <RiTrophyLine />, link: "/leaderboard" },
      ],
    },
    { text: "Challenges", icon: <FaPersonRunning />, link: "/challenges" },
    ...(privilege === "orgadmin" || privilege === "systemadmin"
      ? [
        {
          text: "Rewards",
          icon: <FaHandHoldingHeart />,
          link: "/admin-rewards",
        },
      ]
      : [
        {
          text: "Rewards",
          icon: <FaHandHoldingHeart />,
          link: "/admin-rewards",
        },
      ]),
    { text: "Goal Settings", icon: <GoGoal />, link: "/goal-settings" },
    ...(privilege === "orgadmin" || privilege === "systemadmin"
      ? [
        {
          text: "Org Dashboard",
          icon: <MdDashboard />,
          link: "/org-dashboard",
        },
      ]
      : []),
    ...(privilege === "orgadmin" || privilege === "systemadmin"
      ? [
        {
          text: "Manage User",
          icon: <RiUserSettingsLine />,
          link: "/manage-user",
        },
      ]
      : []),
    ...(privilege === "orgadmin"
      ? [
        {
          text: "HR Pull",
          icon: <AiOutlineUserSwitch />,
          link: "/hr-pull",
        },
      ]
      : []),
    {
      text: "Settings",
      icon: <IoMdSettings />,
      subMenu: [
        {
          text: "Profile",
          icon: <ImProfile />,
          link: "/settings",
        },
        ...(privilege === "systemadmin" || privilege === "orgadmin"
          ? [
            {
              text: "Activity Log",
              icon: <FiActivity />,
              link: "/activity-logs",
            },
          ]
          : []),
        ...(privilege === "systemadmin" ||
          privilege === "orgadmin" ||
          user_role === "creator" ||
          user_role === "all"
          ? [
            {
              text: "Latest News",
              icon: <BiNews />,
              link: "/Latest-news",
            },
          ]
          : []),
        {
          text: "Feedbacks",
          icon: <BiNews />,
          link: "/Feedback-list",
        },
        ...(privilege === "systemadmin" ||
          privilege === "orgadmin" ||
          user_role === "all"
          ? [
            {
              text: "App Configs",
              icon: <BiNews />,
              link: "/App-Configurations",
            },
          ]
          : []),
        ...(privilege === "systemadmin" ||
          privilege === "orgadmin" ||
          user_role === "all"
          ? [
            {
              text: "Badge Configs",
              icon: <BiNews />,
              link: "/badge-Configurations",
            },
          ]
          : []),
        ...(privilege === "systemadmin" ||
          privilege === "orgadmin" ||
          user_role === "all"
          ? [
            {
              text: "Rules Configs",
              icon: <BiNews />,
              link: "/rules-Configurations",
            },
          ]
          : []),
        // ...(privilege === "systemadmin" || privilege === "orgadmin" || user_role === "all"
        // ? [
        //   {
        //     text: "Configs",
        //     icon: <BiCog />,
        //     link: "/org-manage-teams",
        //   },
        // ]
        // : []),
        ...(privilege === "systemadmin" || privilege === "orgadmin"
          ? [
            {
              text: "Configs",
              icon: <BiCog />,
              link:
                privilege === "systemadmin"
                  ? "/org-server-configuration"
                  : "/org-manage-teams",
            },
          ]
          : []),
      ],
    },
  ];

  const footerItems: MenuItem[] = [
    // { text: "Alerts", icon: <RiNotification3Line />, link: "/alerts" },
    {
      text: "Logout",
      icon: <CgLogOut />,
      onClick: () => setShowLogoutDialog(true),
    },
  ];
  const handleSubMenuToggle = (menu: string) => {
    if (activeSubMenu === menu) {
      setActiveSubMenu(null); // Close the submenu if it's already open
    } else {
      setActiveSubMenu(menu); // Open the new submenu
    }
  };

  // const handleMenuClick = (text: string, subMenu?: MenuItem[]) => {
  //   if (subMenu) {
  //     // If the clicked item has a submenu, toggle it
  //     handleSubMenuToggle(text);
  //     setActiveSubMenuItem(null); // Reset active sub-menu item
  //     // Navigate to default route for main tabs
  //     if (text === "Me") navigate("/me-dashboard");
  //     else if (text === "Teams") navigate("/teams-dashboard");
  //   } else {
  //     // If it's a main tab without a submenu
  //     setActiveTab(text); // Set active tab
  //     setActiveSubMenu(null); // Close any open submenu
  //     setActiveSubMenuItem(null); // Reset active sub-menu item
  //     navigate(
  //       text === "Home" ? "/home" : text === "Settings" ? "/settings" : ""
  //     ); // Add navigation logic for other main tabs
  //   }
  // };

  const handleMenuClick = (text: string, subMenu?: MenuItem[]) => {
    if (subMenu) {
      handleSubMenuToggle(text);
      setActiveSubMenuItem(null); // Reset active sub-menu item
      // Navigate to default route
      if (text === "Me") navigate("/me-dashboard");
      else if (text === "Teams") navigate("/team-stats");
      else if (text === "Settings") navigate("/settings");
    } else {
      setActiveTab(text); // Set active tab
      setActiveSubMenu(null); // Close any open submenu
      setActiveSubMenuItem(null); // Reset active sub-menu item when clicking a main tab
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        toggleSidebar();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleSidebar]);

  useEffect(() => {
    const currentPath = location.pathname;

    // First check footer items
    const footerItem = footerItems.find((item) => item.link === currentPath);
    if (footerItem) {
      setActiveTab(footerItem.text);
      setActiveSubMenu(null);
      setActiveSubMenuItem(null);
      return; // ✅ Prevents highlighting main menu items
    }

    // Then check main menu
    const mainItem = menuItems.find((item) => item.link === currentPath);
    if (mainItem) {
      setActiveTab(mainItem.text);
      setActiveSubMenu(null);
      setActiveSubMenuItem(currentPath);
      return;
    }

    // Then check submenus
    for (const item of menuItems) {
      if (item.subMenu) {
        const subItem = item.subMenu.find((sub) => sub.link === currentPath);
        if (subItem) {
          setActiveTab(item.text);
          setActiveSubMenu(item.text);
          setActiveSubMenuItem(currentPath);
          return;
        }
      }
    }
  }, [location.pathname]);

  return (
    <div
      ref={sidebarRef}
      className={`side-nav-container ${isOpen ? "open" : ""}`}
    >
      <IoArrowBackCircleOutline
        className="close-arrow"
        onClick={toggleSidebar}
      />
      <div className="sidebar-menu-items">
        <div className={`nav-upper ${isNavOpen ? "open" : ""}`}>
          <div className="nav-heading">
            {Logo && <img src={Logo} alt="Device" className="device-image" />}
          </div>

          <div className="nav-menu">
            {menuItems.map(({ text, icon, link, subMenu }) => (
              <div key={text}>
                {link ? (
                  <Link
                    to={link}
                    className={`menu-item ${!subMenu && activeTab === text ? "active" : ""
                      }`}
                    onClick={() => {
                      setActiveTab(text);
                      setActiveSubMenu(null);
                      setActiveSubMenuItem(null);
                    }}
                  >
                    <span className="menu-item-icon">{icon}</span>
                    <p>{text}</p>
                  </Link>
                ) : (
                  <div
                    className={`menu-item ${!subMenu && activeTab === text ? "active" : ""
                      }`}
                    onClick={() => handleMenuClick(text, subMenu)}
                  >
                    <span className="menu-item-icon">{icon}</span>
                    <p>{text}</p>
                  </div>
                )}

                {subMenu && activeSubMenu === text && (
                  <div className="submenu">
                    {subMenu.map(({ text: subText, icon: subIcon, link }) => (
                      <Link
                        key={subText}
                        className={`submenu-item ${activeSubMenuItem === link ? "active" : ""
                          }`}
                        to={link || "#"}
                        onClick={() => {
                          setActiveTab(text);
                          setActiveSubMenuItem(link ?? null);
                        }}
                      >
                        <span className="menu-item-icon">{subIcon}</span>
                        <p>{subText}</p>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="nav-footer">
          {footerItems.map(({ text, icon, link, onClick }) => (
            <Link
              key={text}
              className={`menu-item ${location.pathname === link ? "active" : ""
                }`}
              to={link || "#"}
              onClick={(event) => {
                if (onClick) onClick(event);
                setActiveTab(text);
                setActiveSubMenu(null);
                setActiveSubMenuItem(null);
              }}
            >
              <span className="menu-item-icon">{icon}</span>
              <p>{text}</p>
            </Link>
          ))}
        </div>
      </div>

      <ConfirmationDialog
        show={showLogoutDialog}
        onClose={() => setShowLogoutDialog(false)}
        onConfirm={handleLogout}
        onCancel={() => setShowLogoutDialog(false)}
        message="Are you sure you want to logout?"
        confirmText="Logout"
        cancelText="Cancel"
      />
    </div>
  );
};

export default SideBar;
